
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"ql-fill",attrs:{"d":"M16.74 13.814v.44a.54.54 0 01-.605.605h-4.28a.584.584 0 01-.649-.605v-.241c0-2.906 3.4-3.422 3.4-4.555a.777.777 0 00-.848-.781 1.177 1.177 0 00-.836.385c-.275.263-.56.374-.858.131l-.429-.34c-.308-.243-.385-.518-.154-.815a2.972 2.972 0 012.454-1.177 2.454 2.454 0 012.684 2.41c0 2.453-3.18 2.926-3.279 3.938h2.795a.54.54 0 01.605.605zM9 3a1 1 0 00-1 1v4H3V4a1 1 0 00-2 0v10a1 1 0 002 0v-4h5v4a1 1 0 002 0V4a1 1 0 00-1-1z"}})])
          )
        }
      }
    